import React, { useState, useMemo, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import API from '../../../utils/API';
import commonFunctions from '../../../utils/commonFunctions';

function AssignBuildingsModal({ 
  intl,
  selectedSites,
  selectedCms, 
  dataMap,
  loadTable, 
  setSuccess,
  buildingName, setBuildingName,
  raptorBuildings,
  setData,
  generateDataSlice,
  startIndexForTable
}) {

  const [modalError, setModalError] = useState('');

  const handleClose = () => {
    setBuildingName('');
    setModalError('');
  };

  const handleBuildingSelect = (e) => {
    console.log(e.target.value);
    setBuildingName(e.target.value);
  }

  const handleBuildingNameChange = (e) => {
    setBuildingName(e.target.value);
  }

  const handleSubmit = async () => {
    if(buildingName === '') {
      setModalError(<FormattedMessage id="BUILDING_NAME_REQUIRED" />);
    } else {
      try {
        console.log(buildingName, selectedSites, selectedCms.id);
        await API.assignBuilding(buildingName, selectedSites, selectedCms.id);
        commonFunctions.closeModal('assignBldgModal');
        setSuccess(<FormattedMessage id="SITE_MAPPING_SUCCESS" />);
        setBuildingName('');
        setModalError('');
        
        // Instead of calling loadTable which rebuilds everything,
        // just update the building IDs in the existing data
        selectedSites.forEach(siteId => {
          if (dataMap.data[siteId]) {
            dataMap.data[siteId].buildingId = buildingName;
            dataMap.data[siteId].status = <FormattedMessage id="MAPPED" defaultMessage="Mapped"/>;
          }
        });
        
        // Update the UI with the modified data
        setData(generateDataSlice(dataMap, startIndexForTable));
        
      } catch (err) {
        setModalError(<FormattedMessage id="SITE_MAPPING_ERROR" />);
      }
    }
  }

  return (
    <div className="modal fade" id="assignBldgModal" tabIndex="-1" aria-labelledby="receiversModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="buildingNameLabel"><FormattedMessage id="ASSIGN_BUILDING" /></h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {raptorBuildings.length === 0 ? (
                <div>
                  <div className='row'>
                    <div className='firstNameSection mb-2'>
                      <label htmlFor='firstNameLabel' className='col-form-label'>
                        <FormattedMessage id='BUILDING_NAME' />
                      </label>
                      <input
                        id="buildingNameInput"
                        onChange={handleBuildingNameChange}
                        value={buildingName}
                        placeholder={intl.formatMessage({ id: 'ENTER_BUILDING_NAME' })}
                        name='buildingName'
                        className={`form-control`}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <p className="text-center text-muted align-middle mb-0"><small><FormattedMessage id="RAPTOR_BUILDING_NAME_DESC" /></small></p>
                  </div>
                </div>
              ) : (
              <>
                <div className='row'>
                  <div className='firstNameSection mb-2'>
                    <label htmlFor='buildingSelect' className='col-form-label'>
                      <FormattedMessage id='BUILDING_NAME' />
                    </label>
                    <select
                      id="buildingSelect"
                      onChange={handleBuildingSelect}
                      value={buildingName}
                      className="form-select"
                    >
                      <option value="">
                        {intl.formatMessage({ id: 'SELECT_BUILDING' })}
                      </option>
                      {raptorBuildings.map((building) => (
                        <option key={building.uid} value={building.name}>
                          {building.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <p className="text-center text-muted align-middle mb-0">
                    <small>
                      <FormattedMessage id="RAPTOR_BUILDING_SELECT_DESC" />
                    </small>
                  </p>
                </div>
              </>
              )}
            </form>
            {modalError && (
              <div className="text-danger" role="alert">
                {modalError}
              </div>
            )}
          </div>
          <div className="modal-footer justify-content-between">
            <button id="closeBldgBtn" type="button" className="btn back-btn" data-bs-dismiss="modal" onClick={handleClose}>
              <FormattedMessage id="CLOSE" />
            </button>
            <button id="saveBldgBtn" className='btn save-btn' type='button' onClick={handleSubmit}>
              <FormattedMessage id='SAVE' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(AssignBuildingsModal);
